module.exports = __webpack_public_path__ + "img/fund_arrow_up.cf3267d0.svg";